var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavourites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 278.164,
    height: 250,
    viewBox: "0 0 278.164 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_811",
    "data-name": "Group 811",
    transform: "translate(-9904.39 23604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_795",
    "data-name": "Group 795",
    transform: "translate(-359 151)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_263",
    "data-name": "Ellipse 263",
    cx: 125,
    cy: 125,
    r: 125,
    transform: "translate(10277 -23755)",
    fill: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_794",
    "data-name": "Group 794",
    transform: "translate(9893.308 -24304.629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M417.78,616.142s-3.332,27.9-6.33,32.036-13.417,5.852-12.7,9.562,5.566,4.139,7.849,9.136,2.155,16.841,1.649,20.551-10.356,20.043-10.356,20.043l2.142-23.61.569-13.417-28.688-17.27,29.973-9.562,4.854-2.712,6.138-28.4,1.5-.692Z",
    transform: "translate(2.845 8.254)",
    fill: "#e2e5ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M507.408,739.658a4.061,4.061,0,0,1-2.13-.6l-38.493-23.648L428.3,739.055a4.074,4.074,0,0,1-6.092-4.422l10.6-43.913-34.385-29.3a4.071,4.071,0,0,1,2.326-7.159l45.039-3.493,17.237-41.754a4.07,4.07,0,0,1,7.527,0l17.242,41.754,45.034,3.493a4.072,4.072,0,0,1,2.326,7.162l-34.38,29.3,10.594,43.913a4.071,4.071,0,0,1-3.958,5.027Zm-40.625-29.541a4.059,4.059,0,0,1,2.14.61l36.892,22.665-10.154-42.1a4.048,4.048,0,0,1,1.315-4.054l32.96-28.086-43.176-3.347a4.035,4.035,0,0,1-3.447-2.51l-16.527-40.022L450.264,653.3a4.058,4.058,0,0,1-3.46,2.5l-43.165,3.347L436.6,687.242a4.056,4.056,0,0,1,1.323,4.044l-10.162,42.106,36.9-22.671A4.064,4.064,0,0,1,466.783,710.117Zm-20.365-59.4h0Zm40.73,0h0Z",
    transform: "translate(41.788 0)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M401.041,712.93a3.674,3.674,0,0,1-3.664-3.955l2.543-32.756-28.076-17.071a3.673,3.673,0,0,1,1.047-6.707l31.939-7.7,7.56-31.977a3.672,3.672,0,0,1,6.7-1.075l17.2,27.991,32.743-2.691.419,5.091-33.624,2.765a3.652,3.652,0,0,1-3.437-1.754l-15.833-25.77L409.6,646.767a3.666,3.666,0,0,1-2.706,2.724l-29.426,7.1,25.859,15.723a3.65,3.65,0,0,1,1.752,3.421L402.739,705.9l22.941-19.729a3.652,3.652,0,0,1,3.792-.613l27.976,11.551-8.273-19.78,4.711-1.969,9.613,22.984a3.671,3.671,0,0,1-4.785,4.81L428.343,690.62l-24.91,21.422A3.662,3.662,0,0,1,401.041,712.93Zm57.745-12.613,0,.005Zm-58.115-23.641.005,0Zm36.072-36.261.008.013Z",
    transform: "translate(0 5.344)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M459.232,616.142s3.329,27.9,6.327,32.036,13.417,5.852,12.7,9.562-5.566,4.139-7.849,9.136-2.155,16.841-1.649,20.551,10.356,20.043,10.356,20.043l-2.142-23.61-.569-13.417,28.688-17.27-29.973-9.562L470.27,640.9l-6.138-28.4-1.5-.692Z",
    transform: "translate(138.474 8.254)",
    fill: "#e2e5ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M508.521,712.927a3.662,3.662,0,0,1-2.39-.886l-24.912-21.427L450.85,703.153a3.671,3.671,0,0,1-4.79-4.805l9.616-22.987,4.713,1.969-8.275,19.78,27.971-11.548a3.665,3.665,0,0,1,3.794.608L506.823,705.9l-2.339-30.172a3.648,3.648,0,0,1,1.759-3.424l25.852-15.72-29.419-7.1a3.655,3.655,0,0,1-2.709-2.722L493,617.313,477.161,643.1a3.6,3.6,0,0,1-3.434,1.739l-33.621-2.763.421-5.091,32.743,2.691,17.2-27.994a3.674,3.674,0,0,1,6.7,1.078l7.56,31.977,31.939,7.7a3.672,3.672,0,0,1,1.044,6.707l-28.071,17.071,2.541,32.756a3.674,3.674,0,0,1-3.664,3.955Zm.378-36.259-.008.005Z",
    transform: "translate(108.766 5.347)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M465.679,670.294H383.752a2.553,2.553,0,1,1,0-5.106h81.926a2.553,2.553,0,0,1,0,5.106Z",
    transform: "translate(17.268 91.172)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M516.661,670.294H434.734a2.553,2.553,0,1,1,0-5.106h81.927a2.553,2.553,0,0,1,0,5.106Z",
    transform: "translate(96.456 91.172)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M440.589,670.294H419.752a2.553,2.553,0,1,1,0-5.106h20.837a2.553,2.553,0,0,1,0,5.106Z",
    transform: "translate(73.186 91.172)",
    fill: "#2f4265"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourites);
export default __webpack_public_path__ + "static/media/favourites.e8e741714a77fca65e1b837d492932e6.svg";
export { ForwardRef as ReactComponent };